import React, { Component } from 'react';
import { Shield, Lock, Eye, FileText, Phone, Mail, MapPin, ArrowLeft } from 'lucide-react';

class Terms extends Component {
  constructor(props) {
    super(props);
    this.state = {
      
    };
  }

 

  render() {
   
const styles = {
      root: {
        '--primary-dark': '#010A1A',
        '--secondary-dark': '#002C58',
        '--text-primary': '#ffffff',
        '--text-secondary': '#94a3b8',
        '--box-dark-bg': '#1a2332',
        '--icons-color': '#155EEF',
        '--accent-cyan': '#06b6d4',
        '--accent-blue': '#3b82f6'
      }
    };
    return (
         <div className="min-vh-100" 
           style={{
             backgroundColor: 'var(--primary-dark)',
             color: 'var(--text-primary)',
             fontFamily: 'system-ui, -apple-system, sans-serif',
             ...styles.root
           }}>
<section className="py-5 inner-pages">
    <div className="container">
      <div className="row">
        <div className="col-lg-12 mx-auto">
          {/* Header */}
          <div className="text-left mb-5">
            
            <h1 className="display-4 fw-bold mb-3" style={{ color: 'var(--text-primary)' }}>
              Terms & Conditions
            </h1>
            
          </div>

          {/* Content */}
          <div className="p-4 rounded-3" style={{ backgroundColor: 'var(--box-dark-bg)' }}>
            
            <section className="mb-5">
              <h3 className="fw-bold mb-3" style={{ color: 'var(--accent-cyan)' }}>
                1. Services Overview
              </h3>
              <div style={{ color: 'var(--text-secondary)', lineHeight: '1.7' }}>
                <p className="mb-3">
                  Sterling Surveillance Technologies Ltd provides remote security solutions including:
                </p>
                <ul>
                  <li><strong>24/7 Video Monitoring & Incident Response:</strong> AI-driven live video surveillance with instant detection, verification, and response</li>
                  <li><strong>Remote Concierge Services:</strong> Virtual concierge services managing visitors, incidents, and building operations</li>
                  <li><strong>Remote Access Management:</strong> Secure, real-time access control with remote oversight and video verification</li>
                  <li><strong>Time Lapse Videos:</strong> High-quality time-lapse videos for project tracking and promotional purposes</li>
                </ul>
              </div>
            </section>

            <section className="mb-5">
              <h3 className="fw-bold mb-3" style={{ color: 'var(--accent-cyan)' }}>
                2. Service Agreement and Payment Terms
              </h3>
              <div style={{ color: 'var(--text-secondary)', lineHeight: '1.7' }}>
                <p className="mb-3"><strong>Contract Terms:</strong></p>
                <ul className="mb-3">
                  <li>Services begin upon signed agreement and system installation</li>
                  <li>Minimum contract periods may apply based on service package</li>
                  <li>30-day written notice required for service termination</li>
                  <li>Equipment remains property of Sterling Surveillance Technologies Ltd</li>
                </ul>
                <p className="mb-3"><strong>Payment:</strong></p>
                <ul>
                  <li>Monthly billing cycles with payment due within 30 days</li>
                  <li>Late payment fees may apply after 30-day grace period</li>
                  <li>Service suspension possible for accounts 60+ days overdue</li>
                  <li>Installation and setup fees are non-refundable</li>
                </ul>
              </div>
            </section>

            <section className="mb-5">
              <h3 className="fw-bold mb-3" style={{ color: 'var(--accent-cyan)' }}>
                3. Client Responsibilities
              </h3>
              <div style={{ color: 'var(--text-secondary)', lineHeight: '1.7' }}>
                <p className="mb-3">Clients agree to:</p>
                <ul>
                  <li>Provide accurate property and contact information</li>
                  <li>Maintain adequate internet connectivity for system operation</li>
                  <li>Grant authorized access for equipment installation and maintenance</li>
                  <li>Comply with all local laws regarding video surveillance</li>
                  <li>Notify us immediately of system malfunctions or security concerns</li>
                  <li>Maintain current emergency contact information</li>
                  <li>Provide clear escalation procedures for different incident types</li>
                </ul>
              </div>
            </section>

            <section className="mb-5">
              <h3 className="fw-bold mb-3" style={{ color: 'var(--accent-cyan)' }}>
                4. Service Limitations and Response
              </h3>
              <div style={{ color: 'var(--text-secondary)', lineHeight: '1.7' }}>
                <p className="mb-3"><strong>Monitoring Limitations:</strong></p>
                <ul className="mb-3">
                  <li>Services dependent on functioning equipment and internet connectivity</li>
                  <li>Environmental conditions may affect camera visibility</li>
                  <li>AI detection systems may have limitations in certain conditions</li>
                  <li>Response times may vary based on incident type and location</li>
                </ul>
                <p className="mb-3"><strong>Emergency Response:</strong></p>
                <ul>
                  <li>We will contact emergency services when appropriate</li>
                  <li>Response protocols follow client-specified procedures</li>
                  <li>We are not responsible for emergency service response times</li>
                  <li>Clients remain responsible for on-site security personnel if required</li>
                </ul>
              </div>
            </section>

            <section className="mb-5">
              <h3 className="fw-bold mb-3" style={{ color: 'var(--accent-cyan)' }}>
                5. Liability and Insurance
              </h3>
              <div style={{ color: 'var(--text-secondary)', lineHeight: '1.7' }}>
                <p className="mb-3"><strong>Limitation of Liability:</strong></p>
                <ul className="mb-3">
                  <li>Our liability is limited to the monthly service fee amount</li>
                  <li>We are not liable for indirect, consequential, or punitive damages</li>
                  <li>Clients maintain responsibility for comprehensive property insurance</li>
                  <li>We do not guarantee prevention of all security incidents</li>
                </ul>
                <p className="mb-3"><strong>Insurance Requirements:</strong></p>
                <ul>
                  <li>Sterling Surveillance Technologies Ltd maintains professional liability insurance</li>
                  <li>Clients should maintain adequate property and liability coverage</li>
                  <li>Insurance certificates available upon request</li>
                </ul>
              </div>
            </section>

            <section className="mb-5">
              <h3 className="fw-bold mb-3" style={{ color: 'var(--accent-cyan)' }}>
                6. Data and Privacy
              </h3>
              <div style={{ color: 'var(--text-secondary)', lineHeight: '1.7' }}>
                <ul>
                  <li>All video footage and data handled according to our Privacy Policy</li>
                  <li>Clients grant permission for necessary data processing</li>
                  <li>Footage may be shared with law enforcement when legally required</li>
                  <li>Data retention follows industry standards and legal requirements</li>
                  <li>Clients responsible for compliance with local surveillance laws</li>
                </ul>
              </div>
            </section>

            <section className="mb-5">
              <h3 className="fw-bold mb-3" style={{ color: 'var(--accent-cyan)' }}>
                7. Termination and Cancellation
              </h3>
              <div style={{ color: 'var(--text-secondary)', lineHeight: '1.7' }}>
                <p className="mb-3">Either party may terminate services with:</p>
                <ul className="mb-3">
                  <li>30-day written notice for standard termination</li>
                  <li>Immediate termination for material breach of contract</li>
                  <li>Immediate termination for non-payment after 60 days</li>
                </ul>
                <p className="mb-3">Upon termination:</p>
                <ul>
                  <li>Equipment must be returned in good condition</li>
                  <li>Final billing will be prorated to termination date</li>
                  <li>Data retention follows standard privacy policy</li>
                  <li>Outstanding balances remain due and payable</li>
                </ul>
              </div>
            </section>

            <section className="mb-5">
              <h3 className="fw-bold mb-3" style={{ color: 'var(--accent-cyan)' }}>
                8. Force Majeure
              </h3>
              <div style={{ color: 'var(--text-secondary)', lineHeight: '1.7' }}>
                <p>
                  Sterling Surveillance Technologies Ltd is not liable for service interruptions due to circumstances beyond our reasonable control, including natural disasters, power outages, internet service disruptions, government actions, or other force majeure events.
                </p>
              </div>
            </section>

            <section>
              <h3 className="fw-bold mb-3" style={{ color: 'var(--accent-cyan)' }}>
                9. Governing Law and Disputes
              </h3>
              <div style={{ color: 'var(--text-secondary)', lineHeight: '1.7' }}>
                <p className="mb-3">
                  These terms are governed by the laws of [State/Province]. Any disputes will be resolved through:
                </p>
                <ul className="mb-3">
                  <li>Good faith negotiation as the first step</li>
                  <li>Binding arbitration if negotiation fails</li>
                  <li>Jurisdiction in [Local Court System] for legal proceedings</li>
                </ul>
                <p>
                  For questions about these terms, contact us at legal@sterlingprotection.com or +1 (403) 992-1672.
                </p>
              </div>
            </section>

          </div>
        </div>
      </div>
    </div>
  </section>
  </div>
    );
  }
}

export default Terms;